import api from '../../../api/clinique/_analyses'

let categoriesCache = null
let categoriesChargeesA = 0
let categoriesEnCours = null

export default {
    getAnalyses() {
        return new Promise((resolve) => {
            api.getAnalyses().then((response) => {
                resolve(response);
            });
        });
    },

    getCategoriesAnalyse() {
        if (categoriesCache && Date.now() - categoriesChargeesA < 30000) return Promise.resolve(categoriesCache)
        if (categoriesEnCours) return categoriesEnCours
        categoriesEnCours = api.getCategoriesAnalyse().then(response => {
            categoriesCache = response
            categoriesChargeesA = Date.now()
            return response
        }).finally(() => { categoriesEnCours = null })
        return categoriesEnCours
    },

    getAllAnalysesForExterne() {
        return new Promise((resolve, reject) => {
            api.getAllAnalysesForExterne().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListBuletinAnalyses(data) {
        return new Promise((resolve, reject) => {
            api.getListBuletinAnalyses(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}
